// eslint-disable-next-line import/prefer-default-export
export const SET_VALUATION_INFO = 'SET_VALUATION_INFO';
